import { uploadColorMap } from "../FileManagement.constants";
import { snakeCased } from "@/utils/misc/snakeCased";

export const ContentTypeCell = ({ type }: { type: string }) => {
    const color = uploadColorMap[type];
    const finalType = color ? snakeCased(type) : "unknown";
    const uploadTypeLabel = (
        finalType.charAt(0).toUpperCase() + finalType.slice(1)
    ).replace("_", " ");
    return (
        <div className="flex h-full items-center gap-3">
            <div
                className="size-3 rounded-[2px]"
                style={{
                    backgroundColor: uploadColorMap[finalType],
                }}
            />
            <p className="body-s">{uploadTypeLabel}</p>
        </div>
    );
};
